import { FieldValues } from 'react-hook-form';

import { DigitField, Root } from './styles';
import useTimerDigitTextField, { UseTimerDigitTextField } from './vm';

export interface TimerDigitTextFieldProps<T extends FieldValues> extends UseTimerDigitTextField<T> {}

const TimerDigitTextField = <T extends FieldValues>(props: TimerDigitTextFieldProps<T>) => {
  const { handleMouseUp, handleKeyDown, handleKeyUp } = useTimerDigitTextField(props);
  return (
    <Root>
      <DigitField
        {...props}
        type="text"
        characterLimit={1}
        allowedCharacters={/[0-9]/}
        onFocus={(event) => event.target.select()}
        onMouseUp={handleMouseUp}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
      />
    </Root>
  );
};

export default TimerDigitTextField;
